module.exports = __webpack_public_path__ + "static/home_sky_mobile_bg-2aa65b60a4eec3caa10af798b882488b.svg";